import React from 'react'
import { DialogOverlay, useOverlay, Button } from '@fs/zion-ui'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import InfoCard from '../info-card/PersonInfoCard'
import CountHeader from '../count-header/CountHeader'
import Event from './Event'

const worldEventCss = css`
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-row-gap: 0;
  grid-column-gap: 20px;
`

export default function WorldEventsCard({ events, person, ...props }) {
  const [t] = useTranslation()
  const overlay = useOverlay()
  const initialEvents = events.slice(0, 3)
  const overlayEvents = events
  const { birth, gender } = person
  const birthDate = birth?.details?.date?.formalText ? new Date(birth?.details?.date?.formalText) : undefined
  const birthYear = birthDate?.getFullYear()

  function displayEvents(displayedEvents) {
    return (
      <div className={worldEventCss}>
        {displayedEvents.map((event, index) => {
          const key = `world_event_${index}`
          return (
            <Event
              gender={gender}
              key={key}
              event={event}
              disableConnector={index === displayedEvents.length - 1}
              birthYear={birthYear}
            />
          )
        })}
      </div>
    )
  }

  return (
    <InfoCard heading={<CountHeader title={t('info-cards.world-events.header')} count={events.length} />} {...props}>
      {displayEvents(initialEvents)}

      {events.length > 3 && (
        <>
          <Button data-testid="world-events-view-all" linkName="World Events: View All" onClick={overlay.handleClick}>
            {t('info-cards.view-all.action')}
          </Button>

          <DialogOverlay {...overlay} title={`${t('info-cards.world-events.header')} (${events.length})`}>
            {displayEvents(overlayEvents)}
          </DialogOverlay>
        </>
      )}
    </InfoCard>
  )
}

// Stryker disable all
WorldEventsCard.propTypes = {
  /** Array of event objects. */
  events: PropTypes.arrayOf(
    PropTypes.shape({
      year: PropTypes.string.isRequired,
      title: PropTypes.string,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
}
